import { useConfigContext } from "@/state/configContext";
import { assert, formatMoney, groupBy, sum } from "@/helpers/helpers";
import { sitioConfig } from "@/sitio";
import { useAdminContext } from "@/state/adminContext";
import { ComisionesFZod } from "@/state/types";
import { Link } from "@tanstack/react-router";
import { useState } from "react";
import { z } from "zod";
import { SelectCuenta, SelectMoneda } from "./adminSelects";
import { POST } from "@/state/api";
import { router } from "@/main";
import React from "react";

export function ComisionesF({
  data,
  temporada_id,
  fotografo_id,
}: {
  data: z.infer<typeof ComisionesFZod>;
  temporada_id: number;
  fotografo_id: number;
}) {
  const config = useConfigContext();
  const { admin } = useAdminContext();
  const [detallePagos, setDetallePagos] = useState(false);

  if (!data) return "Loading...";

  const contador = admin.permisos?.includes("contador");
  const comision_total = data.fotos
    .map((f) => (f.v * f.comision_pc) / 100)
    .reduce((a, b) => a + b, 0);
  const comision_pc = (data.fotos[0] || {}).comision_pc;

  return (
    <div>
      <ul>
        <li>
          Fotos Vendidas: {data.nfotos}
          {(contador || sitioConfig.fotografoVeComisiones) && (
            <span>
              , comisión: {formatMoney(comision_total)} {config.moneda}
            </span>
          )}
        </li>
        <div className="table-responsive">
          <table style={{ border: "1px solid black" }}>
            <tbody>
              {data.detalle_fotos.map((producto) => (
                <tr key={producto.descripcion}>
                  <td style={{ border: "1px solid black" }}>
                    {" "}
                    {producto.descripcion}{" "}
                  </td>
                  <td style={{ border: "1px solid black", textAlign: "right" }}>
                    {" "}
                    {producto.cantidad.toFixed(2)}{" "}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* (contador || data.premios.length > 0) &&
              <li><a onClick={() => this.setState({detalle_premios: !this.state.detalle_premios})}>Premios</a>: {Number(this.props.total_premios).toFixed(2)} {Config.moneda}
              {data.detalle_premios &&
              <div>
                <ul>
                  {this.props.premios.map(p =>
                    <li key={p.id}>{p.fecha}, {p.obs}: {p.valor}</li>)}
                </ul>
                { contador &&
                <p>Otorgar premio: {this.input("premio", "obs", {placeholder: "Motivo"})}&nbsp; {this.input("premio", "valor", {placeholder: "Valor"})}&nbsp; <button onClick={() => this.send("premio")}>Cargar</button></p>
                }
              </div>
              }
              </li> */}
        {contador && (
          <li>
            <a onClick={() => setDetallePagos(!detallePagos)}>Pagado</a>{" "}
            {formatMoney(data.total_pagos)} {config.moneda}
            {detallePagos && (
              <div>
                <div className="table-responsive">
                  <table border={1}>
                    {data.pagos.map((p) => (
                      <tr key={p.id}>
                        <td style={{ padding: 3 }}>{p.fecha}</td>
                        <td style={{ padding: 3 }}>{p.obs}</td>
                        <td style={{ padding: 3, textAlign: "right" }}>
                          {formatMoney(p.valor)}
                        </td>
                      </tr>
                    ))}
                  </table>
                </div>
                <br />
                <Pagar {...{ temporada_id, fotografo_id }} />
              </div>
            )}
          </li>
        )}
        <br />
        {(contador || sitioConfig.fotografoVeComisiones) && (
          <li>
            <div className="table-responsive">
              <table style={{ border: "1px solid black" }}>
                <tbody>
                  <tr>
                    <th style={{ border: "1px solid black" }}>
                      {" "}
                      Comisiones ({comision_pc}%){" "}
                    </th>
                    <td style={{ border: "1px solid black", textAlign: "right" }}>
                      {" "}
                      {formatMoney(comision_total)}{" "}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid black" }}> Tarjetas </td>
                    <td style={{ border: "1px solid black", textAlign: "right" }}>
                      {" "}
                      {formatMoney(
                        (data.totales_por_color.Blanco * comision_pc) / 100
                      )}{" "}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid black" }}> Efectivo </td>
                    <td style={{ border: "1px solid black", textAlign: "right" }}>
                      {" "}
                      {formatMoney(
                        (data.totales_por_color.Negro * comision_pc) / 100
                      )}{" "}
                    </td>
                  </tr>
                  {/*this.props.premios.length > 0 &&
                  <tr>
                      <td style={{border: "1px solid black"}}> Premios </td>
                      <td style={{border: "1px solid black"}}> {this.props.total_premios} </td>
                  </tr>
              */}
                  <tr>
                    <th style={{ border: "1px solid black" }}>Saldo:</th>
                    <td style={{ textAlign: "right" }}>
                      {formatMoney(
                        comision_total +
                          data.total_premios -
                          data.total_pagos +
                          data.comisionesT
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid black" }}> Tarjetas </td>
                    <td style={{ border: "1px solid black", textAlign: "right" }}>
                      {" "}
                      {data.totales_por_color.Blanco
                        ? formatMoney(
                            (data.totales_por_color.Blanco * comision_pc) / 100 -
                              data.pagos_por_colores.Blanco
                          )
                        : 0}{" "}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid black" }}> Efectivo </td>
                    <td style={{ border: "1px solid black", textAlign: "right" }}>
                      {" "}
                      {data.totales_por_color.Negro
                        ? formatMoney(
                            (data.totales_por_color.Negro * comision_pc) / 100 +
                              data.total_premios -
                              data.pagos_por_colores.Negro
                          )
                        : 0}{" "}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </li>
        )}
      </ul>
      <div className="table-responsive">
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Pedido</th>
              <th>Cantidad</th>
              {contador && <th>Comisión</th>}
              <th>Obs</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(
              groupBy(data.fotos, (x) => x.dia.substring(0, 10))
            ).map(([fecha, pedidos]) => [
              pedidos.map((c) => (
                <tr key={`${c.pedido_id}_${c.comision_pc}`}>
                  <td>{c.fecha.substr(0, 19)}</td>
                  <td>
                    <Link to="/admin/pedido" search={{ id: c.pedido_id }}>
                      {c.codLocal} {c.pedido_id}
                    </Link>
                  </td>
                  <td style={{ textAlign: "right" }}>
                    {Number(c.cantidad).toFixed(2)}
                  </td>
                  {contador && (
                    <td style={{ textAlign: "right" }}>
                      {formatMoney((c.v * c.comision_pc) / 100)} {config.moneda}
                      {/*c.descuento_pc != 0 && "(descuento "+Math.round(c.descuento_pc*100)+"%)"*/}
                    </td>
                  )}
                  <td>{c.observaciones}</td>
                </tr>
              )),
              <tr key={fecha}>
                <th colSpan={2}>{fecha}</th>
                <th style={{ textAlign: "right" }}>
                  {sum(pedidos.map((p) => p.cantidad)).toFixed(2)}
                </th>
                {contador && (
                  <th style={{ textAlign: "right" }}>
                    {formatMoney(
                      sum(pedidos.map((p) => (p.v * p.comision_pc) / 100))
                    )}{" "}
                    {config.moneda}
                  </th>
                )}
                <th />
              </tr>,
            ])}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function PagarInner({
  temporada_id,
  fotografo_id,
  reset,
}: {
  temporada_id: number;
  fotografo_id: number;
  reset: () => unknown;
}) {
  // TODO: usar alguna biblioteca de forms

  const { admin } = useAdminContext();
  const config = useConfigContext();

  assert(admin.cuentas?.[0].id);

  const [cuenta, setCuenta] = useState(admin.cuentas[0].id);
  const [valor, setValor] = useState("");
  const [moneda, setMoneda] = useState(config.moneda);
  const [obs, setObs] = useState("");

  return (
    <p>
      Pagar:
      <SelectCuenta
        value={cuenta}
        onChange={setCuenta}
        cuentas={admin.cuentas}
      />
      &nbsp;
      <input
        size={7}
        value={valor}
        onChange={(e) => setValor(e.target.value)}
        placeholder="Monto"
      />
      &nbsp;
      <SelectMoneda value={moneda} onChange={setMoneda} />
      <input
        value={obs}
        onChange={(e) => setObs(e.target.value)}
        placeholder="Obs"
      />
      <button
        onClick={() => {
          POST("/admin/pago_comision", {
            b: {
              temporada_id,
              fotografo_id,
              cuenta_id: cuenta,
              valor: Number(valor),
              moneda,
              obs,
            },
          }).then(() => {
            router.invalidate();
          });
          reset();
        }}
      >
        Pagar
      </button>
    </p>
  );
}

type WithResetProps = {
  reset: () => void;
};

function withReset<P extends object>(
  Component: React.ComponentType<P & WithResetProps>
) {
  // Omit 'reset' from props exposed to the outside:
  type OuterProps = Omit<P, keyof WithResetProps>;

  return function ResettableWrapper(props: OuterProps) {
    const [version, setVersion] = React.useState(0);
    const reset = React.useCallback(() => setVersion((v) => v + 1), []);

    // Cast props to P (which includes reset) by adding reset prop
    return <Component key={version} {...(props as P)} reset={reset} />;
  };
}

const Pagar = withReset(PagarInner);
